import React, { Component } from "react";
// import {FormGroup,FormControl,ControlLabel,InputGroup,Dropdown,DropdownButton,MenuItem,ButtonToolbar,NavItem } from 'react-bootstrap';
import { DropdownButton, MenuItem, ButtonToolbar } from 'react-bootstrap';
import axios from "axios";
import DataConfig from './../_config.json'
require('./../_css/PopUpOther.css');

export default class InventoryFunction extends Component {
    state = {
        MenuItem: "",
    }
    setDropdownApi = (list) => {
        this.setState({
            MenuItem:
                <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                    {list.map(function (object, i) { return list[i]; })}
                </DropdownButton>
        });
    }
    componentDidMount() {
        var url
        var list = [];
        var token = localStorage.getItem("Token");
        const company = localStorage.getItem("company");
        switch (this.props.type) {
            case "group":
                this.props.SelectSetData(this.props.type, "");
                url = "https://psmdapi.pspl.co.th/CSPDMAINGROUP/GetAll?api_key=" + DataConfig.API_KEY[company] + "&jwt=" + token;
                list = [];
                axios.get(url).then(
                    res => {
                        for (var i = 0; i < res.data.length; i++) {
                            list[i] = <MenuItem onClick={this.onClickMenu.bind(null, (res.data[i].CODE) + "|" + (res.data[i].MYNAMETH))}>{res.data[i].MYNAMETH}</MenuItem>;
                            if (list.length === res.data.length) {
                                this.setDropdownApi(list);
                            }
                        }
                    }
                );
                break;

            case "grade":
                this.props.SelectSetData(this.props.type, "");
                url = "https://psmdapi.pspl.co.th/CSPDSUBGROUP5/GetAll?api_key=" + DataConfig.API_KEY[company] + "&jwt=" + token;
                list = [];
                axios.get(url).then(
                    res => {
                        for (var i = 0; i < res.data.length; i++) {
                            list[i] = <MenuItem onClick={this.onClickMenu.bind(null, (res.data[i].CODE) + "|" + (res.data[i].MYNAMETH))}>{res.data[i].MYNAMETH}</MenuItem>;
                            if (list.length === res.data.length) {
                                this.setDropdownApi(list);
                            }
                        }
                    }
                );
                break;

            case "serialNumber":
                this.props.SelectSetData(this.props.type, "0|ไม่ควบคุม");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ไม่ควบคุม")}>ไม่ควบคุม</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ควบคุม")}>ควบคุม</MenuItem>

                        </DropdownButton>
                }); break;

            case "usability":
                this.props.SelectSetData(this.props.type, "0|ใช้งาน");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ใช้งาน")}>ใช้งาน</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ปิดใช้งาน")}>ปิดใช้งาน</MenuItem>
                        </DropdownButton>
                }); break;

            case "productsset_c":
                this.props.SelectSetData(this.props.type, "1|ใช่สินค้าชุด");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="small" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ใช่สินค้าชุด")}>ใช่สินค้าชุด</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ไม่ใช่สินค้าชุด")}>ไม่ใช่สินค้าชุด</MenuItem>
                        </DropdownButton>
                }); break;

            case "taxcalculation":
                this.props.SelectSetData(this.props.type, "0|คำนวณภาษี");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|คำนวณภาษี")}>คำนวณภาษี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ยกเว็นภาษี")}>ยกเว็นภาษี</MenuItem>
                        </DropdownButton>
                }); break;

            case "sticker":
                this.props.SelectSetData(this.props.type, "01|สีแดง");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|สีแดง")}>สีแดง</MenuItem>
                        </DropdownButton>
                }); break;

            case "costtype":
                this.props.SelectSetData(this.props.type, "0|เฉลี่ย");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|เฉลี่ย")}>เฉลี่ย</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|FIF")}>FIF</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|LOT")}>LOT</MenuItem>
                        </DropdownButton>
                }); break;

            case "category":
                this.props.SelectSetData(this.props.type, "0|สินค้าซื้อมาขายไป");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|สินค้าซื้อมาขายไป")}>สินค้าซื้อมาขายไป</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|สินค้าและบริการ")}>สินค้าและบริการ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|ไม่มีสต๊อกสินค้า(ทรัพย์สิน)")}>ไม่มีสต๊อกสินค้า(ทรัพย์สิน)</MenuItem>
                        </DropdownButton>
                }); break;

            case "sellminus":
                this.props.SelectSetData(this.props.type, "0|ห้ามขายติดลบ");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ห้ามขายติดลบ")}>ห้ามขายติดลบ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ขายติดลบได้")}>ขายติดลบได้</MenuItem>
                        </DropdownButton>
                }); break;

            case "defaultlibrary":
                this.props.SelectSetData(this.props.type, "0|ห้ามขายติดลบ");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i class="far fa-caret-square-down"></i>} noCaret bsStyle="txt-img">
                            <MenuItem onClick={this.onClickMenu.bind(null, "ห้ามขายติดลบ")}>ห้ามขายติดลบ</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "ขายติดลบได้")}>ขายติดลบได้</MenuItem>
                        </DropdownButton>
                }); break;
            default: break;
        }
    }

    onClickMenu = (data) => {
        this.props.SelectSetData(this.props.type, data);
    }

    render() {
        return (
            <ButtonToolbar>
                {this.state.MenuItem}
            </ButtonToolbar>
        )
    }
}
